import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { IEbayLocationsResponse, IEbayPoliciesResponse } from "../models/EbayOffer";

export default function useEbay() {
  const { get, post, put, del } = useApiHelper();
  const queryClient = useQueryClient();
  const staleTime = 1000 * 60 * 60; // 1 hour

  const policies = useQuery({
    queryKey: ["ebayPolicies"],
    queryFn: () => get<IEbayPoliciesResponse>("/ebay/policies"),
    staleTime: staleTime,
  });

  const locations = useQuery({
    queryKey: ["ebayLocations"],
    queryFn: () => get<IEbayLocationsResponse>("/ebay/locations"),
    staleTime: staleTime,
  });

  return {
    policies,
    locations,
  };
}
